/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Evidence_Partially_Supported_DescInputs */

const en_directory_evidence_partially_supported_desc = /** @type {(inputs: Directory_Evidence_Partially_Supported_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The claim is partly confirmed; some details differ from the source.`)
};

const zh_directory_evidence_partially_supported_desc = /** @type {(inputs: Directory_Evidence_Partially_Supported_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该说法部分被证实，个别细节与来源存在出入。`)
};

/**
* | output |
* | --- |
* | "The claim is partly confirmed; some details differ from the source." |
*
* @param {Directory_Evidence_Partially_Supported_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_evidence_partially_supported_desc = /** @type {((inputs?: Directory_Evidence_Partially_Supported_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Evidence_Partially_Supported_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_evidence_partially_supported_desc(inputs)
	return zh_directory_evidence_partially_supported_desc(inputs)
});
export { directory_evidence_partially_supported_desc as "directory.evidence.partially_supported_desc" }